<template>
  <div class="app-container">
    <div class="global-header-wrap">
      <h3>研发样机管理</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '10px' }">
      <div slot="header">
        <div class="global-table-header">
          <div></div>
          <ListSearch ref="listSearch" @listSearchEvn="listSearchEvn" />
        </div>
      </div>
      <div class="global-body-wrap">
        <TableView
          :tableData="tableData"
          :tableProp="tableProp"
          handleWidth="260"
          :handleBtn="handleBtn"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="params.pageSize"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog
      title="编辑"
      :visible="editVisible"
      width="420px"
      @close="editVisible = false"
    >
      <div v-if="currentDevice" class="editContent-info">
        <p>MAC地址：{{ currentDevice.mac }}</p>
        <p>产品型号：{{ currentDevice.model }}</p>
        <p v-if="currentDevice.user && currentDevice.user.department">
          领用人员：{{ currentDevice.user ? currentDevice.user.name : "无" }}-{{
            currentDevice.user ? currentDevice.user.department : "无"
          }}
        </p>
        <p v-else>
          领用人员：{{ currentDevice.user ? currentDevice.user.name : "无" }}
        </p>

        <div v-if="currentDevice.user" class="editContent-date">
          <p>领用日期：</p>

          <el-date-picker v-model="currentDevice.updatedAt" type="date">
          </el-date-picker>
        </div>
        <p v-else>领用日期：无</p>
      </div>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="editConfig">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查看设备绑定记录 -->
    <el-dialog
      title="设备记录"
      :visible="deviceRecordVisible"
      width="70%"
      @close="deviceRecordVisible = false"
      class="deviceRecord-dialog"
    >
      <div class="app-container deviceRecord-container">
        <el-card class="app-table-container">
          <div class="global-body-wrap">
            <TableView :tableData="deviceRecord" :tableProp="recordTableProp" />
          </div>
          <Pagination
            :pageSize="deviceRecordParams.pageSize"
            :total="deviceRecordTotal"
            @pageNum="recordPageNum"
          />
        </el-card>
      </div>
    </el-dialog>

    <!-- 标签打印弹窗 -->
    <el-dialog
      title="打印标签"
      :visible="tabVisible"
      width="370px"
      @opened="openTabHandle"
      @close="tabVisible = false"
    >
      <div id="printContent" class="print-content" ref="printContent">
        <canvas id="deviceMac"></canvas>
        <div v-if="currentDevice" class="printContent-info">
          <p>MAC地址：{{ currentDevice.mac }}</p>
          <p>产品型号：{{ currentDevice.model }}</p>
          <p v-if="currentDevice.user && currentDevice.user.department">
            领用人员：{{
              currentDevice.user ? currentDevice.user.name : "无"
            }}-{{ currentDevice.user ? currentDevice.user.department : "无" }}
          </p>
          <p v-else>
            领用人员：{{ currentDevice.user ? currentDevice.user.name : "无" }}
          </p>

          <p>
            领用日期：{{ currentDevice.updatedAt | formatDate("yyyy-MM-dd") }}
          </p>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="tabVisible = false">取消</el-button>
        <el-button type="primary" @click="printSelectedContent">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TableView from "@/components/tableView";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";
import JsBarcode from "jsbarcode";
import printJS from "print-js";

export default {
  components: {
    ListSearch,
    TableView,
    Pagination,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    tableProp() {
      let tableProp = [
        {
          prop: "mac",
          label: "MAC",
        },
        {
          prop: "model",
          label: "设备型号",
        },
        {
          prop: "user.name",
          label: "绑定人",
          obj: true,
        },
        {
          prop: "updatedAt",
          label: "更新时间",
        },
      ];
      return tableProp;
    },
    handleBtn() {
      return [
        { style: "delBtn", type: "unbind", title: "解绑", showKey: "user" },
        {
          style: "checkDetailsBtn",
          type: "edit",
          title: "编辑",
          showKey: "user",
        },
        {
          style: "checkDetailsBtn",
          type: "record",
          title: "查看记录",
        },
        {
          style: "checkDetailsBtn",
          type: "printTab",
          title: "打印标签",
          showKey: "user",
        },
      ];
    },
    recordTableProp() {
      let tableProp = [
        {
          prop: "device.model",
          label: "设备型号",
          obj: true,
        },
        {
          prop: "actionValue",
          label: "操作",
        },
        {
          prop: "user.name",
          label: "当前绑定人",
          obj: true,
        },
        {
          prop: "originalUser.name",
          label: "原绑定人",
          obj: true,
        },
        {
          prop: "createdAt",
          label: "时间",
        },
      ];
      return tableProp;
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      params: { pageSize: 20, page: 1 },
      currentDevice: null,
      // 设备记录
      deviceRecordVisible: false,
      deviceRecordParams: { pageSize: 20, page: 1 },
      deviceRecordTotal: 0,
      deviceRecord: [],
      editVisible: false,
      tabVisible: false,
    };
  },
  methods: {
    async getList() {
      let res = await this.$http.getInternalDeviceList(this.params);
      this.tableData = res.data.results;
      this.total = res.data.count;
    },

    async unbindHandle() {
      try {
        await this.$confirm(null, "确定解绑该设备？", {
          confirmButtonText: this.$t("commonMsg.confirm"),
          cancelButtonText: this.$t("commonMsg.cancel"),
          showClose: false,
          center: true,
        });
        await this.$http.unbindInternalDevice(this.currentDevice._id);
        this.getList();
      } catch (error) {}
    },

    tableHandle({ type, data }) {
      this.currentDevice = data;
      switch (type) {
        case "edit":
          this.editVisible = true;
          break;
        case "record":
          this.checkRecordHandle();
          break;
        case "unbind":
          this.unbindHandle();
          break;
        case "printTab":
          this.tabVisible = true;

          break;

        default:
          break;
      }
    },
    async openTabHandle() {
      JsBarcode("#deviceMac", this.currentDevice.mac, {
        width: 1.3,
        height: 55,
        displayValue: false,
        format: "CODE128",
      });
    },
    async printSelectedContent() {
      const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
      printJS({
        printable: "printContent", // 标签元素id
        type: "html",
        header: "",
        targetStyles: ["*"],
        style,
      });
    },

    listSearchEvn(val) {
      this.params.search = val;
      this.getList();
    },

    pageNum(page) {
      this.params.page = page;
      this.getList();
    },

    // ================== 设备记录 ==================

    async checkRecordHandle() {
      await this.getInternalDeviceRecord();
      this.deviceRecordVisible = true;
    },

    async getInternalDeviceRecord() {
      let res = await this.$http.getInternalDeviceRecord(
        this.currentDevice._id,
        this.deviceRecordParams
      );
      this.deviceRecord = res.data.results;
      for (let item of this.deviceRecord) {
        item.actionValue = this.deviceActionFilter(item.action);
      }
      this.deviceRecordTotal = this.deviceRecord.length;
    },

    deviceActionFilter(action) {
      let str = "";
      switch (action) {
        case "firstBind":
          str = "首次绑定";
          break;
        case "bindByUser":
          str = "用户换绑";
          break;
        case "bindByAdmin":
          str = "管理员换绑";
          break;
        case "unbindByAdmin":
          str = "管理员解绑";
          break;
        default:
          break;
      }
      return str;
    },
    async recordPageNum(page) {
      this.deviceRecordParams.page = page;
      this.checkRecordHandle();
    },

    async editConfig() {
      const dateObject = new Date(this.currentDevice.updatedAt);
      const date = dateObject.toISOString();
      await this.$http.editInternalDevice(this.currentDevice._id, {
        boundTime: date,
      });
      this.getList();
      this.editVisible = false;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.deviceRecord-container {
  height: 600px;
}
.deviceRecord-dialog {
  .el-dialog__body {
    padding: 0;
  }
}

.print-content {
  padding: 10px;
  background: #fff;
  border: 1px solid #eee;
  .printContent-info {
    padding: 0 10px;
  }
}

.editContent-info {
  line-height: 40px;
  .editContent-date {
    display: flex;
    align-items: center;
  }
}
</style>
